import React, { Component } from 'react'
import { connect } from 'react-redux';
import { ReactComponent as Group } from '../assets/icons/Group.svg'
import { ReactComponent as RightIcon } from '../assets/icons/rightArrow.svg'
import { ReactComponent as EllipseIcon } from '../assets/icons/ellipseGroup.svg'
import { ReactComponent as SquareIcon } from '../assets/icons/square.svg'
import { ReactComponent as TextIcon } from '../assets/icons/textGroup.svg'
import { ReactComponent as LockIcon } from '../assets/icons/lock.svg'
import { ReactComponent as GroupEye } from '../assets/icons/groupEye.svg'
import { ReactComponent as Options } from '../assets/icons/options.svg'
import { ReactComponent as Line } from '../assets/icons/lineGroup.svg'
import { ReactComponent as DownIcon } from '../assets/icons/downArrow.svg'
import { ReactComponent as ImageIcon } from '../assets/icons/imageGroup.svg'
import { ReactComponent as TriangleIcon } from '../assets/icons/Triangle.svg'
import AnnotationObj from './AnnotationObj';
import { selectedObject } from '../actions/wizard'

export class AnnotationLayer extends Component<any, any> {

  private optionsLayerRef: React.RefObject<HTMLDivElement>;

  constructor(props) {
    super(props)
    this.optionsLayerRef = React.createRef<HTMLDivElement>();
    this.handleClickOutside = this.handleClickOutside.bind(this);
    this.state = {
      layerOpen: false,
      showOptions: false,
      showOptionsForObj: false

    }
  }

  handleClickOutside(event) {
    if (this?.optionsLayerRef?.current && !this.optionsLayerRef?.current?.contains(event.target)) {
      this.setState({ showOptions: false })
    }
  };

  componentDidMount() {
    document.addEventListener('click', this.handleClickOutside, true);
  }



  handleIncreaseLayerZindex = () => {

    this.props.grp.forEachObject((i) => {
      if (i.type.includes(this.props.layerName.toLowerCase())) {
        this.props.grp.removeWithUpdate(i);
        this.props.fabricInstance.add(i);
        this.props.fabricInstance.remove(i);
        this.props.grp.addWithUpdate(i);
        i.bringToFront();

        this.props.grp.set("dirty", true);
      }
    });
    this.setState({ showOptions: false })
    this.props.fabricInstance.renderAll();

  }

  handleDecreaseLayerZindex = () => {

    this.props.grp.forEachObject((i) => {
      if (i.type.includes(this.props.layerName.toLowerCase())) {
        this.props.grp.removeWithUpdate(i);
        this.props.fabricInstance.add(i);
        this.props.fabricInstance.remove(i);
        this.props.grp.addWithUpdate(i);
        i.sendToBack();

        this.props.grp.set("dirty", true);
      }
    });
    this.setState({ showOptions: false })
    this.props.fabricInstance.renderAll();
  }

  highlightLayerObjects = () => {

    // var selection = new this.props.fabricInstance.ActiveSelection(this.props.layerObjects, {
    //     canvas: this.props.fabricInstance
    //   });
    this.props.fabricInstance.setActiveObject(this.props.layerObjects);
    this.props.fabricInstance.renderAll();

  }

  handleUngroupLayer = () => {
    this.props.grp.forEachObject((i) => {
      if (i.type.includes(this.props.layerName.toLowerCase())) {
        this.props.grp.removeWithUpdate(i);
        this.props.fabricInstance.add(i);
      }
    });

    if (this.props.grp._objects.length == 0) {
      this.props.fabricInstance.remove(this.props.grp);
    }
    this.props.selectedObject([]);
    this.setState({ showOptions: false })
    this.props.fabricInstance.renderAll();
  }





  render() {
    const { layerObjects, layerName, grp } = this.props;

    let st = {
      border: 'none'
    }
    if (this.state.layerOpen) {
      st.border = '1px solid #E5212D'
    }
    
    return (
      <div>
        {layerObjects.length > 0 && <div className={"layer"} ref={this.optionsLayerRef}>
          {/* <div className="layer-header">
            <div onClick={() => { this.setState({ layerOpen: !this.state.layerOpen }) }} style={{ display: 'flex', flexDirection: 'row' }}>
              <div style={{ padding: '3px' }}>{!this.state.layerOpen ? <RightIcon></RightIcon> : <DownIcon></DownIcon>}</div>
              <div style={{ padding: '4px' }}>
                {layerName == 'Ellipse' && <EllipseIcon></EllipseIcon>}
                {layerName == 'Rectangle' && <SquareIcon></SquareIcon>}
                {layerName == 'Line' && <Line></Line>}
                {layerName == 'Text' && <TextIcon></TextIcon>}
                {layerName == 'Image' && <ImageIcon></ImageIcon>}
                {layerName == 'Triangle' && <TriangleIcon />}
              </div>
              <div style={{ padding: '4px' }}>{layerName}</div>
            </div>
            {
              <div style={{ display: 'flex', flexDirection: 'row' }}>
                <div style={{ padding: '4px' }} onClick={() => this.setState({ showOptions: !this.state.showOptions })}>
                  <Options></Options>
                </div>
                {
                  this.state.showOptions && <div ref={this.optionsLayerRef} className='layering-container'>

                    {
                      <div className="layering-dropdown">
                        <ul className="layer-opts">
                          <li className="layer-opts" onClick={this.handleIncreaseLayerZindex}>To Top </li>
                          <li className="layer-opts" onClick={this.handleDecreaseLayerZindex}>To Back</li>
                          <li className="layer-opts" onClick={this.handleUngroupLayer}>Ungroup</li>
                        </ul>
                      </div>
                    }
                  </div>
                }
              </div>
            }
          </div> */}
          {
            layerObjects.map((obj, i) => {
              return <AnnotationObj index={i} layerName={layerName} obj={obj} grp={grp}></AnnotationObj>
            })
          }
        </div>
        }



      </div>
    )
  }
}

export default connect(
  (state: any) => ({
    fabricInstance: state.wizard.fabricInstance,
  }),
  {
    selectedObject
  }
)(AnnotationLayer)